import { Card, CardContent } from "@/components/ui/card";

const STATUS = {
  new: { label: "Novo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  update: { label: "Atualizar", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  duplicate: { label: "Repetido", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  error: { label: "Erro", cls: "bg-red-50 text-red-700 border-red-200" },
};

const brl = (v) =>
  v == null ? "—" : v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const ImportPreview = ({ kind, rows }) => (
  <Card data-testid="import-preview">
    <CardContent className="p-0 overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
          <tr>
            <th className="px-3 py-2 w-14">Linha</th>
            <th className="px-3 py-2">Nome</th>
            {kind === "procedures" && <th className="px-3 py-2 w-28">Valor</th>}
            {kind === "procedures" && <th className="px-3 py-2 w-32">SUS</th>}
            {kind === "procedures" && <th className="px-3 py-2 w-28">Especialid.</th>}
            {kind === "procedures" && <th className="px-3 py-2 w-20">Retenção</th>}
            <th className="px-3 py-2 w-24">Situação</th>
            <th className="px-3 py-2">Observação</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const st = STATUS[r.status] || STATUS.error;
            return (
              <tr key={`${r.line}-${r.name}`} className="border-b border-slate-100"
                  data-testid={`import-row-${r.line}`}>
                <td className="px-3 py-2 text-slate-400">{r.line}</td>
                <td className="px-3 py-2 text-slate-900">{r.name || r.raw}</td>
                {kind === "procedures" && <td className="px-3 py-2 text-slate-700">{brl(r.valor_bruto)}</td>}
                {kind === "procedures" && <td className="px-3 py-2 text-slate-500 font-mono text-xs">{r.sus_code || "—"}</td>}
                {kind === "procedures" && <td className="px-3 py-2 text-slate-500">{r.specialty || "—"}</td>}
                {kind === "procedures" && (
                  <td className="px-3 py-2 text-slate-500">
                    {r.retention_rate == null ? "padrão" : `${Math.round(r.retention_rate * 100)}%`}
                  </td>
                )}
                <td className="px-3 py-2">
                  <span className={`inline-block rounded-full border px-2 py-0.5 text-xs ${st.cls}`}
                        data-testid={`import-status-${r.line}`}>
                    {st.label}
                  </span>
                </td>
                <td className="px-3 py-2 text-slate-500 text-xs">{r.message || "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
